// Consumer app (listeners / streamers)
const APP_BASE_URL = "https://app.starfarm.com";
// Artist portal (StarFarm artist SPA — login + artist signup)
const ARTIST_PORTAL_BASE_URL = "https://artist.starfarm.com";

/** Primary marketing “Log in” → artist portal (avoids app.starfarm.com first hop). */
export const LOGIN_URL = `${ARTIST_PORTAL_BASE_URL}/login`;
/** Generic signup → artist portal registration (artist/streamer choice in-app). */
export const REGISTER_URL = `${ARTIST_PORTAL_BASE_URL}/registration`;

export const REGISTER_ARTIST_URL = `${ARTIST_PORTAL_BASE_URL}/registration`;
/** Streamer-specific path stays on consumer app if that route only exists there. */
export const REGISTER_STREAMER_URL = `${APP_BASE_URL}/register/streamer`;

/** Optional: listener login on consumer app (use in UI if you split CTAs). */
export const APP_LOGIN_URL = `${APP_BASE_URL}/login`;

// Social media links
export const facebookHref = "#";
export const twitterHref = "#";
export const instagramHref = "#";
